export default "__VITE_ASSET__DQXDysEm__"